import gcaLogo from "./gcaLogo.png";
import historyLogo from "./historyLogo.png";

export interface ProjectDefinition {
  name: string;
  title: string;
  desc?: string;
  icon?: string;
  image?: string;
  href: string;
}

export const projectDefinitions: ProjectDefinition[] = [
  {
    name: "ranker",
    title: "Ranker",
    desc: "Greyhound racing rankings and statistics",
    image: gcaLogo,
    href: "https://ranker.scottdb.net"
  },
  {
    name: "history",
    title: "History of Greyhound Racing",
    desc: "A blog about the history of greyhound racing in Australia",
    image: historyLogo,
    href: "https://historyofgreyhoundracing.com/"
  }
];
